<template>
  <div class="contents">
    <div class="gallery_wrap">
      <h4 class="tit">기부후원 단체</h4>
        <ul class="filter">
          <li>
            <a 
              @click="getCategorizedDonationGroup('')" 
              :class="currentCategorySeq === '' ? 'active' : ''"
            >전체{{ getCurrentCategoryCount('') }}</a>
          </li>
          <li
            v-for="category in categories"
          >
            <a 
              @click="getCategorizedDonationGroup(category.categorySeq)"
              :class="currentCategorySeq === category.categorySeq ? 'active' : ''"
            >{{ category.name }}{{ getCurrentCategoryCount(category.categorySeq) }}</a>
          </li>
        </ul>
        <ul class="gallery photo">
          <li
            v-for="group in donationGroups"
          >
            <a @click="toDetail(group.donationGroupSeq)">
              <div class="gallery_img">
                <img v-if="group.thumbnailPath" :src="$getImgUrl(group.thumbnailPath)" alt="">
                <img v-else src="../../assets/images/common/donation_img_01.png" alt="">
              </div>
              <div class="gallery_txt">
                <h5>{{ group.groupName }}</h5>
                <div>{{ group.groupExplain }}</div>
                <p>{{ $truncateText( $stripHtmlTags(group.editorHtml), 40 ) }}</p>
              </div>
            </a>
          </li>
        </ul>
        <CustomerServicePagination
          :totalPages = "totalPages()"
          :currentPage = currentPage
          @changePage = "changePage"
        />
    </div>
</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CustomerServicePagination from '../common/CustomerServicePagination.vue';

const donationGroupModule = 'donationGroupModule'
const categoryModule = 'categoryModule'

export default {
  components: {
    CustomerServicePagination
  },
  
  data () {
    return {
      currentPage: 1,
      currentCategorySeq: ''
    }
  },

  methods: {
    ...mapActions(donationGroupModule, [
      'requestDonationGroupList'
    ]),

    ...mapActions(categoryModule, [
      'requestCategoryList',
      'removeCategories'
    ]),

    async getCategorizedDonationGroup(categorySeq) {
      this.currentPage = 1
      this.currentCategorySeq = categorySeq
      const {currentPage, currentCategorySeq} = this
      await this.requestDonationGroupList({currentPage, currentCategorySeq})
    },

    getCurrentCategoryCount(categorySeq) {
      if (this.currentCategorySeq === categorySeq) {
        return '(' + this.donationGroupCount + ')'
      }
      else return ''
    },

    totalPages () {
      return Math.ceil(this.donationGroupCount / 8);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, currentCategorySeq} = this
      await this.requestDonationGroupList({currentPage, currentCategorySeq})
    },

    toDetail(donationGroupSeq) {
      this.$router.push({
        name: 'DonationGroupDtlPage',
        params: { donationGroupSeq: donationGroupSeq.toString() }
      })
    }
  },

  computed: {
    ...mapState(donationGroupModule, [
      'donationGroups',
      'donationGroupCount'
    ]),

    ...mapState(categoryModule, [
      'categories'
    ])
  },

  async mounted () {
    const {currentPage, currentCategorySeq} = this
    await this.requestDonationGroupList({currentPage, currentCategorySeq})
    await this.requestCategoryList('기부후원단체')
  },

  beforeDestroy() {
    this.removeCategories()
  }
}
</script>
<style>
    
</style>